<div class="toolbar">
  <span>
    <button matButton="text" [disabled]="isBusy()" (click)="backToProductDetail()">
      <span>
        <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
        <span class="buttonLabel">Back To Details</span>
      </span>
    </button>
  </span>
  <span class="spacer"></span>
  <span>
    <button matButton="text" [disabled]="isBusy()" (click)="saveProductSkuSlots()">
      <span>
        <mat-icon class="size-16">done</mat-icon>
        <span class="buttonLabel">Save</span>
      </span>
    </button>
  </span>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="instructions">
    <p>Remove any slots that are no longer valid from the mapped list.</p>
    <p>Add new slots by typing the slot name in the input box and clicking the 'Add' button</p>
    <p>The list of available sku slots takes a while to load, but this will not stop you from adding slots if you know
    the slot name.</p>
    <p>All known entries will be available and suggested as you type the slot name after the list has loaded.</p>
  </div>
  @if (product) {
    <div class="productDetail">
      <div class="inputRow">
        <span class="displayLabel">Product ID:</span>
        <span class="valueLabel">{{ productId() }}</span>
        <span class="displayLabel">Description:</span>
        <span class="valueLabel">{{ product.description }}</span>
        <span class="displayLabel">Where Used:</span>
        <span class="valueLabel">{{ product.whereUsed }}</span>
      </div>
      <div class="inputRow">
        <div class="inputPanel">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="availableSkuSelected($event.option.value)">
            @for (slot of filteredAvailable | async; track slot) {
              <mat-option [value]="slot">
                {{ slot }}
              </mat-option>
            }
          </mat-autocomplete>
          <input class="inputField" matInput placeholder="Sku Slot Name" [value]="newSlotName() || ''"
            [matAutocomplete]="auto" (keyup.enter)="addSlot()" [formControl]="availableSkuInput"/>
          <button matButton="elevated" (click)="addSlot()" class="inputButton primary-button">
            <span>
              <mat-icon class="size-16">add</mat-icon>
              <span class="buttonLabel">Add</span>
            </span>
          </button>
        </div>
        <div class="mappingsPanel">
          @if (existingSlots()) {
            <select size="10" class="selectionList" [(ngModel)]="selectedExistingSlot"
              (keyup.delete)="removeExistingSlot()">
              @for (slot of existingSlots(); track slot) {
                <option>{{ slot }}</option>
              }
            </select>
          }
          <button matButton="elevated" (click)="removeExistingSlot()" [disabled]="!selectedExistingSlot()"
            class="removeButton warn-button">
            <span>
              <mat-icon class="size-16">delete</mat-icon>
              <span class="buttonLabel">Remove</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  }
</div>
@if (isBusy()) {
  <span class="busyIndicator">
    <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
    <span class="busyLabel">Please Wait...</span>
  </span>
}
